// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing Page Styles */

/* Header Styles */
.header {
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: rgba(1, 5, 17, 0.6);
  backdrop-filter: blur(8px);
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 60px;
  margin: 0 auto;
  width: 100%;
}

.brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.brand-logo {
  width: 26px;
  height: 26px;
}

.brand-name {
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.2px;
  font-size: 25px;
}

.nav-desktop {
  display: flex;
  gap: 40px;
  align-items: center;
}

.nav-desktop a {
  color: #bdbdbd;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.nav-desktop a:hover {
  color: #ffffff;
}

.auth-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn {
  border: 0;
  background: transparent;
  color: #e6e6e6;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-ghost {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-ghost:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
}

.btn-primary {
  background: linear-gradient(90deg, #7b5cff 0%, #a884ff 100%);
  color: #0c0c12;
  font-weight: 600;
  border: none;
}

.btn-primary:hover {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

.mobile-menu-btn {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.mobile-menu-btn span {
  width: 24px;
  height: 2px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(11, 11, 18, 0.98);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateY(-100%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
}

.mobile-menu-open {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.nav-mobile {
  display: flex;
  flex-direction: column;
  padding: 24px 60px;
  gap: 20px;
}

.nav-mobile a {
  color: #bdbdbd;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.nav-mobile a:hover {
  color: #ffffff;
}

.mobile-auth-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 60px 24px;
}

/* Hero Styles */
.hero {
  width: 100%;
  /* min-height: 70vh; */
  /* min-height: '753px'; */
  /* margin: 80px auto 34px auto; */
  color: #e6e6e6;
  position: relative;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  z-index: 5;
  /* padding: 40px 20px; */
  /* padding-top: 168px; */
}

.hero-content {
  max-width: 1224px;
  width: 100%;
  text-align: center;
}

.hero-title {
  width: 100%;
  font-size: 65px;
  line-height: 1.15;
  color: #e8e8e8;
  letter-spacing: 0.4px;
  font-weight: 700;
  padding: 0px 110px;
}

.hero-title .highlight {
  color: #cfcfe6;
}

.br-desktop {
  display: none;
}

.hero-subtitle {
  width: 100%;
  color: #a5a5b3;
  font-size: 21px;
  line-height: 28px;
  /* margin: 0px 184px; */
  padding: 0px 184px;
  text-align: center;
}

.hero-cta {
  margin-top: 28px;
}

.cta-button {
  width: 100%;
  max-width: 342px;
  min-width: 330px;
  height: 50px;
  border: 0;
  padding: 16px 32px;
  border-radius: 12px;
  background: linear-gradient(180deg, #622CD5 0%, #33176F 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;
}

.cta-button:hover {
  filter: brightness(1.05);
  transform: translateY(-2px);
}

.cta-button .arrow {
  margin-left: 8px;
}

.credit-note {
  margin-top: 16px;
  color: white;
  font-size: 16px;
}

/* Solution Categories Styles */
.solution-categories {
  padding: 120px 0px 0px 0px;
  color: #ffffff;
  position: relative;
  background: inherit;
}

.solution-categories::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.solution-categories-container {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.solution-categories-header {
  width: 100%;
  text-align: center;
  position: relative;
  display: flex;
}

.solution-categories-bg {
  width: '100%';
  width: 100%;
  height: 700px;
  display: flex;
  flex: 1 1;
  justify-content: center;
  position: relative;
}

.solution-categories-bg-image {
  width: 'auto';
  height: 'auto';
  top: '0';
  position: 'absolute';
  object-fit: 'cover';
  scale: '0.87';
}

.solution-categories-title {
  width: 100%;
  max-width: 441px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 auto 20px auto;
  color: #e8e8e8;
}

.solution-categories-title-highlight {
  color: #ffffff;
  font-size: 56px;
  font-weight: 700;
}

.solution-categories-description {
  width: 100%;
  max-width: 650px;
  font-size: 18px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0 auto;
}

.solution-cards {
  padding: 0px 130px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.solution-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(147, 51, 234, 0.3);
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  position: relative;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;
}

.solution-card::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: linear-gradient(135deg, rgba(147, 51, 234, 0.3), rgba(147, 51, 234, 0.1));
  border-radius: 20px;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.solution-card:hover::before {
  opacity: 1;
}

.solution-card:hover {
  transform: translateY(-5px);
  border-color: rgba(147, 51, 234, 0.4);
}

.solution-card-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
}

.solution-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.solution-icon:hover {
  transform: scale(1.1);
}
.solution-icon-image{
  width: 128px;
  height: 128px;
}
.solution-card-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 24px;
  line-height: 1.3;
}

.solution-card-description {
  font-size: 16px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0 0 32px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.solution-card-cta {
  background: linear-gradient(180deg, #622CD5 0%, #33176F 100%);
  color: #ffffff;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.solution-card-cta:hover {
  background: linear-gradient(180deg, #33176F 0%, #622CD5 100%);
  transform: translateY(-2px);
}

/* FAQ Section Styles */
.faq-section {
  background: inherit;
  padding: 120px 174px;
  color: #ffffff;
}

.faq-container {
  max-width: 100%;
  margin: 0 auto;
}

.faq-header {
  text-align: center;
  margin-bottom: 80px;
}

.faq-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 24px;
  color: #e8e8e8;
}

.faq-title-highlight {
  color: #ffffff;
  font-size: 56px;
  font-weight: 700;
}

.faq-subtitle {
  font-size: 18px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0;
}

.faq-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  background: inherit;
  position: relative;
}

.faq-item {
  position: relative;
  display: flex;
  flex-direction: column;
  background: inherit;
  border: none;
  padding: 30px 134px;
  margin: 0;
  background: inherit;
}

.faq-item::before {
  content: '';
  position: absolute;
  left: 100px;
  top: 50%;
  width: 2px;
  height: 24px;
  background: #5E5472;
  transform: translateY(-50%);
  filter: blur(0.5px);
}

.faq-item::after {
  content: '';
  position: absolute;
  right: 100px;
  top: 50%;
  width: 2px;
  height: 24px;
  background: #5E5472;
  transform: translateY(-50%);
  filter: blur(0.5px);
}

.faq-content::before,
.faq-content::after {
  content: '';
  position: absolute;
  top: -100px;
  bottom: -40px; /* stretches with total content height */
  width: 1px;
  pointer-events: none;
}

.faq-content::before {
  left: 100px; /* align with item padding */
  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);
  filter: blur(0.3px);
}

.faq-content::after {
  right: 100px; /* align with item padding */
  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);
  filter: blur(0.3px);
}

.faq-divider {
  display: block;
  height: 1px;
  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);
  margin: 0 0; /* stops at vertical borders */
}

.faq-question {
  width: 100%;
  background: transparent;
  border: none;
  color: #ffffff;
  padding: 0 0 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}

.faq-question:hover {
  color: #e8e8e8;
}

.faq-question-open {
  color: #ffffff;
}

.faq-question-text {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  flex: 1 1;
}

.faq-toggle-icon {
  font-size: 20px;
  font-weight: bold;
  transition: transform 0.3s ease;
  min-width: 24px;
  text-align: center;
  margin-left: 16px;
}

.faq-question-open .faq-toggle-icon {
  transform: rotate(180deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.faq-answer-open {
  max-height: 500px;
}

.faq-answer-content {
  padding: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #bdbdbd;
}

/* Pricing Plans Styles */


.pricing-plans::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-image: 
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px; */
  pointer-events: none;
}

.pricing-plans-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.pricing-plans-header {
  text-align: center;
  margin-bottom: 80px;
}

.pricing-plans-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 24px;
  color: #ffffff;
}

.pricing-plans-subtitle {
  font-size: 18px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.pricing-plans-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.pricing-plan-card {
  background: rgba(255, 255, 255, 0.02);
  padding: 60px 40px;
  text-align: center;
  position: relative;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.pricing-plan-card:last-child {
  border-right: none;
}

.pricing-plan-card:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-5px);
}

.pricing-plan-header {
  margin-bottom: 40px;
}

.pricing-plan-name {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px;
  letter-spacing: 2px;
}

.pricing-plan-price {
  margin-bottom: 16px;
}

.pricing-plan-amount {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
}

.pricing-plan-period {
  font-size: 16px;
  color: #bdbdbd;
  margin-left: 4px;
}

.pricing-plan-description {
  font-size: 16px;
  color: #bdbdbd;
  margin: 0;
  line-height: 1.5;
}

.pricing-plan-features {
  margin-bottom: 40px;
}

.pricing-features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.pricing-feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.pricing-feature-item:last-child {
  margin-bottom: 0;
}

.pricing-feature-icon {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #9333ea, #7c3aed);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}

.pricing-feature-text {
  font-size: 16px;
  color: #ffffff;
  line-height: 1.4;
}

.pricing-plan-cta {
  margin-top: auto;
}

.pricing-plan-button {
  background: linear-gradient(135deg, #9333ea, #7c3aed);
  color: #ffffff;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 200px;
}

.pricing-plan-button:hover {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(147, 51, 234, 0.3);
}

/* Pricing Table Styles */
.pricing-table {
  padding: 150px 190px 0px 190px;
  color: #ffffff;
  position: relative;
}

.pricing-container {
  max-width: 1200px;
  margin-top: 150px;
  margin: 0 auto;
}

.pricing-header {
  text-align: center;
  margin-bottom: 60px;
}

.pricing-title {
  max-width: 441px;
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0;
  margin: 0 auto 20px auto;
  padding: 0 80px;
  color: #ffffff;
}

.pricing-subtitle {
  font-size: 16px;
  line-height: 24px;
  color: #bdbdbd;
  margin: 0 auto;
  padding: 0 120px;
  max-width: 652px;
}

.pricing-plans {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  border-radius: 20px;
  overflow: hidden;
  background: transparent;
  color: #ffffff;
  position: relative;
  width: 100%;
}

.pricing-card {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0px 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  flex: 1 1;
  min-width: 0;
}

.pricing-card:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(255, 255, 255, 0.1);
}

.pricing-card-header {
  text-align: center;
  margin-bottom: 40px;
}

.pricing-price {
  margin-bottom: 16px;
}

.pricing-amount {
  font-size: 30px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
}

.pricing-period {
  font-size: 16px;
  color: #bdbdbd;
  margin-left: 4px;
}

.pricing-description {
  font-size: 14px;
  color: #bdbdbd;
  margin: 0;
  line-height: 1.5;
}

.pricing-features {
  flex: 1 1;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
}

.pricing-feature-list {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.pricing-feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 0 auto;
}

.pricing-feature-icon {
  width: 24px;
  height: 24px;
  background: rgba(147, 51, 234, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9333ea;
  flex-shrink: 0;
}

.pricing-feature-text {
  font-size: 14px;
  color: #ffffff;
  line-height: 1.4;
}

.pricing-cta {
  margin: auto auto;
  width: 100%;
  max-width: 200px;
}

.pricing-button {
  width: 100%;
  background: linear-gradient(180deg, rgba(98, 44, 213, 0.8), rgba(51, 23, 111, 0.8));
  color: #ffffff;
  border: none;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 
    inset 0 1px 0 rgba(255, 255, 255, 0.3),
    inset 0 -1px 0 rgba(0, 0, 0, 0.2); */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.pricing-button:hover {
  background: linear-gradient(180deg, rgba(51, 23, 111, 0.9), rgba(98, 44, 213, 0.9));
  transform: translateY(-2px);
  /* box-shadow:  */
    /* inset 0 1px 0 rgba(255, 255, 255, 0.4),
    inset 0 -1px 0 rgba(0, 0, 0, 0.3),
    0 10px 25px rgba(98, 44, 213, 0.3); */
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}

/* Pricing Table Responsive */
@media (max-width: 1024px) {
  .pricing-table {
    padding: 150px 130px 0px 130px;
  }
  
  .pricing-title {
    font-size: 42px;
  }
  
  .pricing-card {
    padding: 50px 30px;
  }
}

@media (max-width: 768px) {
  .pricing-table {
    padding: 150px 20px 0px 20px;
  }
   
  .pricing-title {
    font-size: 36px;
  }
  
  .pricing-subtitle {
    font-size: 16px;
  }
  
  .pricing-plans {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .pricing-card {
    padding: 0px 25px;
  }
  
  .pricing-card:not(:last-child)::after {
    display: none;
  }
  
  .pricing-feature-item {
    margin-bottom: 12px;
  }
}

@media (max-width: 480px) {
  .pricing-table {
    padding: 150px 15px 60px 15px;
  }
  
  
  .pricing-title {
    font-size: 28px;
    line-height: 1.3;
  }
  
  .pricing-subtitle {
    font-size: 14px;
  }
  
  .pricing-card {
    padding: 0px 20px;
  }
  
  .pricing-plan-name {
    font-size: 16px;
    letter-spacing: 1px;
  }
  
  .pricing-amount {
    font-size: 32px;
  }
  
  .pricing-period {
    font-size: 14px;
  }
  
  .pricing-description {
    font-size: 13px;
  }
  
  .pricing-feature-icon {
    width: 20px;
    height: 20px;
  }
  
  .pricing-feature-text {
    font-size: 13px;
  }
  
  .pricing-button {
    padding: 14px 20px;
    font-size: 14px;
  }
}

@media (max-width: 320px) {
  .pricing-title {
    font-size: 24px;
  }
  
  .pricing-plan-name {
    font-size: 14px;
  }
  
  .pricing-amount {
    font-size: 28px;
  }
  
  .pricing-button {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* Workflow Features Styles */
.workflow-features {
  width: 100%;
  padding: 120px 130px;
  color: #ffffff;
  background: inherit;
}

.workflow-features-container {
  width: 100%;
  margin: 0 auto;
}

.workflow-features-header {
  max-width: 650px;
  margin: 0 auto 80px auto;
  text-align: center;
}

.workflow-features-title {
  width: 100%;
  max-width: 441px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 auto 24px auto;
  color: #e8e8e8;
}

.workflow-features-title-highlight {
  color: #a5a5b3;
}

.workflow-features-description {
  font-size: 16px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0 auto;
}

.workflow-features-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  /* gap: 60px 40px; */
  position: relative;
  align-items: start;
}
.workflow-feature-card {
  text-align: center;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 240px;
}

.workflow-feature-card:nth-child(1)::before,
.workflow-feature-card:nth-child(2)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: linear-gradient(180deg, #716786 0%, #232227 100%);
  filter: blur(1px);
}

.workflow-feature-card:nth-child(3)::before,
.workflow-feature-card:nth-child(4)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: linear-gradient(0deg, #716786 0%, #232227 100%);
  filter: blur(1px);
}

.workflow-feature-card::after {
  content: '';
  position: absolute;
  left: 1px;
  top: 50%;
  width: 2px;
  height: 24px;
  background: #5E5472;
  transform: translateY(-50%);
  filter: blur(0.5px);
}

.workflow-feature-icon {
  width: 60px;
  height: 60px;
  background: #1a1a1a;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  color: #ffffff;
}

.workflow-feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.3;
}

.workflow-feature-description {
  font-size: 14px;
  line-height: 1.6;
  color: #bdbdbd;
  margin: 0;
}

/* Footer Styles */
.footer {
  position: relative;
  overflow: hidden;
}

.footer-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.footer-container {
  position: relative;
  z-index: 1;
  max-width: 1440px;
  padding-top: clamp(32px, 6vw, 61px);
  padding-bottom: clamp(24px, 4vw, 46px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 397px;
}

.footer-main {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  /* padding-left: clamp(20px, 9vw, 130px);
  padding-right: clamp(20px, 4vw, 40px); */
  padding: 0px 130px;
}

.footer-brand {
  max-width: 337px;
  min-width: 260px;
  /* margin-right: clamp(24px, 6vw, 84px); */
  margin-bottom: 24px;
}

.footer-brand-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.footer-brand-logo {
  width: 24px;
  height: 24px;
}

.footer-brand-name {
  color: white;
  font-size: 25px;
  font-weight: 600;
  letter-spacing: -4%;
}

.footer-brand-desc {
  color: rgba(255,255,255,0.7);
  font-size: 14px;
  margin: 0;
}

.footer-nav {
  display: flex;
  gap: 130px;
  flex-wrap: wrap;
}

.footer-nav-section {
  display: flex;
  flex-direction: column;
}

.footer-nav-heading {
  color: white;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 16px;
  line-height: 22px;
}

.footer-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 9px;
}

.footer-nav-link {
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  font-size: 14px;
  line-height: 17px;
}

.footer-nav-link:hover {
  color: rgba(255,255,255,1);
}

.footer-copyright {
  color: rgba(255,255,255,0.7);
  font-size: 13px;
  margin: 0;
  text-align: center;
}

/* Media Queries */

@media (min-width: 1200px) {
  .hero {
    min-height: 753px;
  }
  
  .hero-title {
    font-size: 65px;
    line-height: 130.2%;
  }
  
  .br-desktop {
    display: inline;
  }
  
  /* Hide hamburger menu on large screens */
  .nav-desktop {
    display: flex !important;
  }
  
  .auth-actions {
    display: flex !important;
  }
  
  .mobile-menu-btn {
    display: none !important;
  }
  
  .mobile-menu {
    display: none !important;
  }


}


@media (max-width: 1200px) and (min-width: 900px) {
  .nav-desktop {
    display: flex !important;
  }
  .auth-actions {
    display: flex !important;
  }
  .mobile-menu-btn {
    display: none !important;
  }
  .mobile-menu {
    display: none !important;
  }
  
  .hero {
    min-height: 753px;
  }
  
  .hero-title {
    font-size: 55px;
  }
  
  .br-desktop {
    display: inline;
  }

  .pricing-table {
    padding: 150px 130px 0px 130px;
  }

  
}

@media (max-width: 900px) {
  .header-container {
    padding: 16px 20px;
  }
  
  .nav-desktop {
    display: none !important;
  }
  
  .auth-actions {
    display: none !important;
  }
  
  .mobile-menu-btn {
    display: flex !important;
  }
  
  .mobile-menu {
    display: block !important;
  }
  
  .hero {
    margin: 80px auto 34px auto;
    min-height: 650px;
    padding: 40px 110px;
  }
  
  .hero-title {
    font-size: 55px;
    padding: 0px 20px;
  }
  
  .hero-subtitle {
    font-size: 15px;
    display: none;
  }

  .pricing-table {
    padding: 100px 60px 0px 60px;
  }
}

@media (min-width: 1200px) {
  .footer-main {
    flex-direction: row;
    align-items: flex-start;
  }
 
  .footer-nav {
    justify-content: space-between;
    align-items: flex-start;
  }
}

@media (max-width: 1199px) {
  /* .footer-main {
    flex-direction: column;
    align-items: center;
    text-align: center;
  } */
  
  .footer-brand {
    margin-right: 0;
    margin-bottom: 32px;
  }
  
  .footer-nav {
    /* justify-content: space-between; */
    flex-direction: row;
    flex-wrap: wrap;
    gap: 80px;
  }
}

/* FAQ Section Responsive */
@media (max-width: 1200px) {
  .faq-section {
    padding: 100px 100px;
  }
}

@media (max-width: 1024px) {
  .faq-section {
    padding: 100px 60px;
  }
  
  .faq-title {
    font-size: 42px;
  }
  
  .faq-title-highlight {
    font-size: 48px;
  }
  
  .faq-subtitle {
    font-size: 16px;
  }
  
  .faq-question-text {
    font-size: 16px;
  }
  
  /* .faq-item {
    padding: 25px 80px;
    margin: 0;
  } */

  .faq-content::before { left: 80px; }
  .faq-content::after { right: 80px; }
  .faq-divider { margin: 0 80px; }
  .faq-item::before { left: 80px; }
  .faq-item::after { right: 80px; }
  

}

@media (max-width: 768px) {
  .faq-section {
    padding: 80px 40px;
  }
  
  .faq-header {
    margin-bottom: 60px;
  }
  
  .faq-title {
    font-size: 36px;
  }
  
  .faq-title-highlight {
    font-size: 40px;
  }
  
  .faq-subtitle {
    font-size: 15px;
  }
  
  .faq-content {
    grid-template-columns: 1fr;
  }
  
  /* .faq-item {
    padding: 20px 40px;
    margin: 0;
  } */

  .faq-content::before { left: 40px; }
  .faq-content::after { right: 40px; }
  .faq-divider { margin: 0 40px; }
  .faq-item::before { left: 40px; }
  .faq-item::after { right: 40px; }

  .faq-item {
    padding: 30px 60px;
  }
   
  .faq-question-text {
    font-size: 15px;
  }
  
  .faq-toggle-icon {
    font-size: 18px;
    margin-left: 12px;
  }
  
  .faq-answer-content {
    font-size: 14px;
    line-height: 1.5;
  }
}

@media (max-width: 480px) {
  .faq-section {
    padding: 60px 20px;
  }
  
  .faq-header {
    margin-bottom: 50px;
  }
  
  .faq-title {
    font-size: 28px;
    line-height: 1.3;
  }
  
  .faq-title-highlight {
    font-size: 32px;
  }
  
  .faq-subtitle {
    font-size: 14px;
  }
  
  .faq-item {
    padding: 15px 20px;
    margin: 0;
  }

  .faq-content::before { left: 20px; }
  .faq-content::after { right: 20px; }
  .faq-divider { margin: 0 20px; }
  
  .faq-question {
    padding: 0 0 10px 0;
  }
  
  .faq-question-text {
    font-size: 14px;
    padding-right: 10px;
  }
  
  .faq-toggle-icon {
    font-size: 16px;
    margin-left: 10px;
  }
  
  .faq-answer-content {
    font-size: 13px;
    line-height: 1.4;
  }
}

@media (max-width: 320px) {
  .faq-item {
    padding: 12px 10px;
    margin: 0;
  }

  .faq-content::before { left: 10px; }
  .faq-content::after { right: 10px; }
  .faq-divider { margin: 0 10px; }
  
  .faq-title {
    font-size: 24px;
  }
  
  .faq-title-highlight {
    font-size: 28px;
  }
  
  .faq-subtitle {
    font-size: 13px;
  }
  
  .faq-question-text {
    font-size: 13px;
  }
  
  .faq-toggle-icon {
    font-size: 14px;
    margin-left: 8px;
  }
  
  .faq-answer-content {
    font-size: 12px;
  }
}

/* Pricing Plans Responsive */
@media (max-width: 1024px) {
  
  .pricing-plans-title {
    font-size: 42px;
  }
  
  .pricing-plans-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .pricing-plan-card {
    padding: 50px 30px;
  }
  
  .pricing-plan-amount {
    font-size: 40px;
  }
  
  .pricing-feature-text {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .pricing-plans {
    padding: 0px 20px;
  }
  
  .pricing-plans-header {
    margin-bottom: 60px;
  }
  
  .pricing-plans-title {
    font-size: 36px;
  }
  
  .pricing-plans-subtitle {
    font-size: 16px;
  }
  
  .pricing-plans-grid {
    grid-template-columns: 1fr;
    border-radius: 16px;
  }
  
  .pricing-plan-card {
    padding: 40px 30px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .pricing-plan-card:last-child {
    border-bottom: none;
  }
  
  .pricing-plan-header {
    margin-bottom: 30px;
  }
    
  .pricing-plan-amount {
    font-size: 36px;
  }
  
  .pricing-plan-description {
    font-size: 15px;
  }
  
  .pricing-plan-features {
    margin-bottom: 30px;
  }
  
  .pricing-feature-item {
    margin-bottom: 12px;
  }
  
  .pricing-feature-text {
    font-size: 14px;
  }
  
  .pricing-plan-button {
    padding: 14px 28px;
    font-size: 15px;
  }

  .pricing-button {
    width: 200px;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .pricing-plans {
    padding: 0px 15px;
  }
  
  .pricing-plans-header {
    margin-bottom: 50px;
  }
  
  .pricing-plans-title {
    font-size: 28px;
    line-height: 1.3;
  }
  
  .pricing-plans-subtitle {
    font-size: 14px;
  }
  
  .pricing-plan-card {
    padding: 30px 20px;
  }
  
  .pricing-plan-header {
    margin-bottom: 25px;
  }
  
  .pricing-plan-name {
    font-size: 16px;
    margin-bottom: 15px;
  }
  
  .pricing-plan-amount {
    font-size: 32px;
  }
  
  .pricing-plan-period {
    font-size: 14px;
  }
  
  .pricing-plan-description {
    font-size: 14px;
  }
  
  .pricing-plan-features {
    margin-bottom: 25px;
  }
  
  .pricing-feature-item {
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .pricing-feature-icon {
    width: 20px;
    height: 20px;
  }
  
  .pricing-feature-text {
    font-size: 13px;
  }
  
  .pricing-plan-button {
    padding: 12px 24px;
    font-size: 14px;
  }
}

@media (max-width: 320px) {
  .pricing-plans-title {
    font-size: 24px;
  }
  
  .pricing-plans-subtitle {
    font-size: 13px;
  }
  
  .pricing-plan-card {
    padding: 25px 15px;
  }
  
  .pricing-plan-name {
    font-size: 14px;
  }
  
  .pricing-plan-amount {
    font-size: 28px;
  }
  
  .pricing-feature-text {
    font-size: 12px;
  }
  
  .pricing-plan-button {
    padding: 10px 20px;
    font-size: 13px;
  }
}

/* Solution Categories Responsive */
@media (max-width: 1200px) {
  .solution-categories {
    padding: 100px 80px 0px 80px;
  }
  .solution-categories-bg {
    height: 650px;
  }
  .solution-categories-title {
    font-size: 30px;
  }

  .solution-categories-description {
    font-size: 12px;
    max-width: 700px;
  }

  .solution-categories-description {
    font-size: 16px;
    max-width: 700px;
  }
  .solution-cards {
    padding: 0px 10px;
  }

  .solution-card {
    /* padding: 50px 30px; */
    background-size: cover !important;
    background-position: center !important;
  }
  
  .solution-card-title {
    font-size: 28px;
  }
  
  .solution-card-description {
    font-size: 15px;
  }
}

@media (max-width: 1024px) {
  .solution-categories-title {
    font-size: 30px;
  }

  /* .solution-categories-description {
    display: none;
  } */

  .solution-categories-bg-image {
    scale: 0.8;
  }

  .solution-cards {
    padding: 0px 0px;
  }
 

}

@media (max-width: 768px) {
  .solution-categories {
    padding: 80px 30px 0px 30px;
  }

  .solution-categories-bg {
    height: 600px;
  }

  .solution-categories-bg-image {
    scale: 0.7;
  }
  
  .solution-categories-header {
    /* margin-bottom: 60px; */
    padding: 50px 25px;
  }
  
  .solution-categories-title {
    font-size: 30px;
  }
  
  .solution-categories-title-highlight {
    font-size: 40px;
  }
  
  .solution-categories-description {
    font-size: 15px;
    max-width: 100%;
    margin-top: 20px;
  }
  
  .solution-cards {
    gap: 40px;
    padding: 0px 20px;
  }
  
  .solution-card {
    padding: 40px 25px;
    background-size: cover !important;
    background-position: center !important;
  }
  
  .solution-card-icons {
    gap: 15px;
    margin-bottom: 30px;

  }
  
  .solution-card-title {
    font-size: 24px;
  }
  
  .solution-card-description {
    font-size: 14px;
    line-height: 1.5;
  }
  
  .solution-card-cta {
    padding: 14px 28px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .solution-categories {
    padding: 60px 20px 0px 20px;
  }
  .solution-categories-bg-image {
    scale: 0.6;
  }
  
  .solution-categories-header {
    padding: 40px 20px;
  }
  
  .solution-categories-title {
    font-size: 28px;
    line-height: 1.3;
  }
  .solution-categories-description {
    display: none;
  }

  .solution-categories-bg {
    height: 400px;
  }
  .solution-icon-image{
    width: 64px;
    height: 64px;
  }
  .solution-categories-title-highlight {
    font-size: 32px;
  }
  
  .solution-categories-description {
    font-size: 14px;
    line-height: 1.5;
    margin-top: 16px;
  }
  
  .solution-cards {
    gap: 30px;
  }
  
  .solution-card {
    padding: 30px 20px;
    background-size: cover !important;
    background-position: center !important;
  }
  
  .solution-card-icons {
    gap: 12px;
    margin-bottom: 25px;
    flex-wrap: wrap;
  }
  
  .solution-icon {
    width: 45px;
    height: 45px;
  }
  
  .solution-card-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .solution-card-description {
    font-size: 13px;
    line-height: 1.4;
    margin-bottom: 25px;
  }
  
  .solution-card-cta {
    padding: 12px 24px;
    font-size: 13px;
  }
}

@media (max-width: 320px) {
  .solution-categories-title {
    font-size: 24px;
  }

  .solution-categories-bg-image {
    scale: 0.5;
  }
  
  .solution-categories-title-highlight {
    font-size: 28px;
  }
  
  .solution-icon {
    width: 40px;
    height: 40px;
  }
  
  .solution-card-title {
    font-size: 18px;
  }
  
  .solution-card-description {
    font-size: 12px;
  }
  
  .solution-card-cta {
    padding: 10px 20px;
    font-size: 12px;
  }
}

/* Testimonials Section Styles */
.testimonials-section {
  padding: 170px 130px 0px 130px ;
  background: inherit;
  color: #ffffff;
  position: relative;
}

.testimonials-container {
  width: 100%;
  margin: 0 auto;
}

.testimonials-header {
  text-align: center;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.testimonials-title {
  width: 441px;
  padding: 0 40px;
  margin: 0 auto;
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;
  margin: 0 0 24px;
  color: #ffffff;
}

.testimonials-subtitle {
  width: 100%;
  max-width: 541px;
  padding: 0 40px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 24px;
  color: #bdbdbd;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  position: relative;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  position: relative;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.testimonial-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.testimonial-content {
  flex: 1 1;
  margin-bottom: 30px;
}

.testimonial-quote {
  font-size: 14px;
  line-height: 150%;
  color: #e8e8e8;
  margin: 0;
  /* font-style: italic; */
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 16px;
}

.testimonial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.testimonial-author-info {
  flex: 1 1;
}

.testimonial-author-name {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 4px;
  line-height: 1.3;
}

.testimonial-author-title {
  font-size: 14px;
  color: #bdbdbd;
  margin: 0;
  line-height: 1.4;
}

/* Testimonials Section Responsive */
@media (max-width: 1200px) {
  .testimonials-section {
    padding: 100px 80px;
  }
}

@media (max-width: 1024px) {
  .testimonials-section {
    padding: 100px 40px;
  }
  
  .testimonials-title {
    font-size: 42px;
  }
  
  .testimonials-grid {
    gap: 30px;
  }
  
  .testimonial-card {
    padding: 35px 25px;
  }
  
  .testimonial-quote {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .testimonials-section {
    padding: 80px 30px;
  }
  
  .testimonials-header {
    margin-bottom: 60px;
  }
  
  .testimonials-title {
    font-size: 36px;
    line-height: 1.3;
  }
  
  .testimonials-subtitle {
    font-size: 16px;
    line-height: 1.5;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .testimonial-card {
    padding: 30px 25px;
    margin: 0 auto;
    max-width: 500px;
  }
  
  .testimonial-quote {
    font-size: 15px;
    line-height: 1.6;
  }
  
  .testimonial-author {
    gap: 14px;
  }
  
  .testimonial-avatar {
    width: 45px;
    height: 45px;
  }
  
  .testimonial-author-name {
    font-size: 15px;
  }
  
  .testimonial-author-title {
    font-size: 13px;
  }
}

/* Large tablets and small desktops */
@media (min-width: 768px) and (max-width: 1200px) {
 
  .workflow-features-title {
    font-size: 42px;
  }
}

/* Mobile devices */
@media (max-width: 768px) {
  .workflow-features {
    /* margin: 0 130px 0 130px; */
    padding: 40px 50px;
  }
  
  .workflow-features-header {
    margin-bottom: 40px;
  }
  
  .workflow-features-description {
    font-size: 14px;
    line-height: 1.5;
  }
  
  .workflow-features-grid {
    grid-template-columns: 1fr;
  }
  
  .workflow-feature-card {
    padding: 15px;
  }
  
  .workflow-feature-icon {
    width: 45px;
    height: 45px;
    margin-bottom: 20px;
  }
  
  .workflow-feature-title {
    font-size: 18px;
    margin-bottom: 12px;
  }
  
  .workflow-feature-description {
    font-size: 13px;
    line-height: 1.4;
  }
}

/* Extra small devices */
@media (max-width: 768px) {
  /* .workflow-features {
    margin: 0 130px 0 130px;
    padding: 30px 10px;
  } */
  
  .workflow-features-title {
    font-size: 24px;
  }
  
  .workflow-features-description {
    font-size: 13px;
  }
  
  .workflow-feature-icon {
    width: 40px;
    height: 40px;
  }
  
  .workflow-feature-title {
    font-size: 16px;
  }
  
  .workflow-feature-description {
    font-size: 12px;
  }

  .footer-nav {
    gap: 20px;
  }

  .hero {
    margin: 60px auto 34px auto;
    min-height: 600px;
    padding: 40px 60px;
  }
  
  .hero-title {
    font-size: 40px;
    padding: 0px 20px;
  }

  .footer-main {
    padding: 0px 80px;
  }
}

@media (max-width: 480px) {
  .testimonials-section {
    padding: 60px 20px;
  }
  
  .testimonials-header {
    margin-bottom: 50px;
  }
  
  .testimonials-title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 16px;
  }
  
  .testimonials-subtitle {
    font-size: 14px;
    line-height: 1.5;
  }
  
  .testimonials-grid {
    gap: 25px;
  }
  
  .testimonial-card {
    padding: 25px 20px;
    margin: 0 auto;
    max-width: 100%;
  }
  
  .testimonial-content {
    margin-bottom: 25px;
  }
  
  .testimonial-quote {
    font-size: 14px;
    line-height: 1.5;
  }
  
  .testimonial-author {
    gap: 12px;
    flex-wrap: wrap;
  }
  
  .testimonial-avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
  
  .testimonial-author-info {
    flex: 1 1;
    min-width: 0;
  }
  
  .testimonial-author-name {
    font-size: 14px;
    margin-bottom: 2px;
  }
  
  .testimonial-author-title {
    font-size: 12px;
    line-height: 1.4;
  }

  .hero {
    margin: 40px auto 34px auto;
    min-height: 500px;
    padding: 40px 20px;
  }
  
  .hero-title {
    font-size: 35px;
    padding: 0px 20px;
  }
  .cta-button {
    padding: 16px 10px;
  }

  .footer-main {
    padding: 0px 40px;
  }
}

@media (max-width: 320px) {
  .testimonials-section {
    padding: 50px 15px;
  }
  
  .testimonials-title {
    font-size: 24px;
    line-height: 1.2;
  }
  
  .testimonials-subtitle {
    font-size: 13px;
    line-height: 1.4;
  }
  
  .testimonial-card {
    padding: 20px 15px;
    margin: 0 auto;
    max-width: 100%;
  }
  
  .testimonial-quote {
    font-size: 13px;
    line-height: 1.4;
  }
  
  .testimonial-author {
    gap: 10px;
  }
  
  .testimonial-avatar {
    width: 35px;
    height: 35px;
  }
  
  .testimonial-author-name {
    font-size: 13px;
    margin-bottom: 1px;
  }
  
  .testimonial-author-title {
    font-size: 11px;
    line-height: 1.3;
  }
}

/* Workflow Features Responsive */
`, "",{"version":3,"sources":["webpack://./src/assets/css/landing.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;EAC9C,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,MAAM;EACN,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,wCAAwC;EACvD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,4BAA4B;EAC1C,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6DAA6D;EAC7D,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;;;AAGzB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;+BAG6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mFAAmF;EACnF,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB;;wCAEsC;EACtC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,mFAAmF;EACnF,2BAA2B;EAC3B,iBAAiB;IACf;;yCAEqC;EACvC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;;EAGA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB;0CACwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;;AAGF;;;AAGA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;;AAGF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;KAIG;;EAEH;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;KAGG;;EAEH,uBAAuB,UAAU,EAAE;EACnC,sBAAsB,WAAW,EAAE;EACnC,eAAe,cAAc,EAAE;EAC/B,oBAAoB,UAAU,EAAE;EAChC,mBAAmB,WAAW,EAAE;;;AAGlC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;KAGG;;EAEH,uBAAuB,UAAU,EAAE;EACnC,sBAAsB,WAAW,EAAE;EACnC,eAAe,cAAc,EAAE;EAC/B,oBAAoB,UAAU,EAAE;EAChC,mBAAmB,WAAW,EAAE;;EAEhC;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA,uBAAuB,UAAU,EAAE;EACnC,sBAAsB,WAAW,EAAE;EACnC,eAAe,cAAc,EAAE;;EAE/B;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA,uBAAuB,UAAU,EAAE;EACnC,sBAAsB,WAAW,EAAE;EACnC,eAAe,cAAc,EAAE;;EAE/B;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;;AAGF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,SAAS;IACT,mBAAmB;;EAErB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;EAEE;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE;;;KAGG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC","sourcesContent":["/* Landing Page Styles */\n\n/* Header Styles */\n.header {\n  width: 100%;\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: rgba(1, 5, 17, 0.6);\n  backdrop-filter: blur(8px);\n}\n\n.header-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 60px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.brand-logo {\n  width: 26px;\n  height: 26px;\n}\n\n.brand-name {\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: 0.2px;\n  font-size: 25px;\n}\n\n.nav-desktop {\n  display: flex;\n  gap: 40px;\n  align-items: center;\n}\n\n.nav-desktop a {\n  color: #bdbdbd;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.nav-desktop a:hover {\n  color: #ffffff;\n}\n\n.auth-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.btn {\n  border: 0;\n  background: transparent;\n  color: #e6e6e6;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.btn-ghost {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-ghost:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.btn-primary {\n  background: linear-gradient(90deg, #7b5cff 0%, #a884ff 100%);\n  color: #0c0c12;\n  font-weight: 600;\n  border: none;\n}\n\n.btn-primary:hover {\n  filter: brightness(1.05);\n  transform: translateY(-1px);\n}\n\n.mobile-menu-btn {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n}\n\n.mobile-menu-btn span {\n  width: 24px;\n  height: 2px;\n  background: #ffffff;\n  transition: all 0.3s ease;\n}\n\n.mobile-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: rgba(11, 11, 18, 0.98);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  transform: translateY(-100%);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 1000;\n}\n\n.mobile-menu-open {\n  transform: translateY(0);\n  opacity: 1;\n  visibility: visible;\n}\n\n.nav-mobile {\n  display: flex;\n  flex-direction: column;\n  padding: 24px 60px;\n  gap: 20px;\n}\n\n.nav-mobile a {\n  color: #bdbdbd;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.nav-mobile a:hover {\n  color: #ffffff;\n}\n\n.mobile-auth-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0 60px 24px;\n}\n\n/* Hero Styles */\n.hero {\n  width: 100%;\n  /* min-height: 70vh; */\n  /* min-height: '753px'; */\n  /* margin: 80px auto 34px auto; */\n  color: #e6e6e6;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n  z-index: 5;\n  /* padding: 40px 20px; */\n  /* padding-top: 168px; */\n}\n\n.hero-content {\n  max-width: 1224px;\n  width: 100%;\n  text-align: center;\n}\n\n.hero-title {\n  width: 100%;\n  font-size: 65px;\n  line-height: 1.15;\n  color: #e8e8e8;\n  letter-spacing: 0.4px;\n  font-weight: 700;\n  padding: 0px 110px;\n}\n\n.hero-title .highlight {\n  color: #cfcfe6;\n}\n\n.br-desktop {\n  display: none;\n}\n\n.hero-subtitle {\n  width: 100%;\n  color: #a5a5b3;\n  font-size: 21px;\n  line-height: 28px;\n  /* margin: 0px 184px; */\n  padding: 0px 184px;\n  text-align: center;\n}\n\n.hero-cta {\n  margin-top: 28px;\n}\n\n.cta-button {\n  width: 100%;\n  max-width: 342px;\n  min-width: 330px;\n  height: 50px;\n  border: 0;\n  padding: 16px 32px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #622CD5 0%, #33176F 100%);\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 18px;\n  transition: all 0.2s ease;\n}\n\n.cta-button:hover {\n  filter: brightness(1.05);\n  transform: translateY(-2px);\n}\n\n.cta-button .arrow {\n  margin-left: 8px;\n}\n\n.credit-note {\n  margin-top: 16px;\n  color: white;\n  font-size: 16px;\n}\n\n/* Solution Categories Styles */\n.solution-categories {\n  padding: 120px 0px 0px 0px;\n  color: #ffffff;\n  position: relative;\n  background: inherit;\n}\n\n.solution-categories::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n\n.solution-categories-container {\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.solution-categories-header {\n  width: 100%;\n  text-align: center;\n  position: relative;\n  display: flex;\n}\n\n.solution-categories-bg {\n  width: '100%';\n  width: 100%;\n  height: 700px;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  position: relative;\n}\n\n.solution-categories-bg-image {\n  width: 'auto';\n  height: 'auto';\n  top: '0';\n  position: 'absolute';\n  object-fit: 'cover';\n  scale: '0.87';\n}\n\n.solution-categories-title {\n  width: 100%;\n  max-width: 441px;\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 auto 20px auto;\n  color: #e8e8e8;\n}\n\n.solution-categories-title-highlight {\n  color: #ffffff;\n  font-size: 56px;\n  font-weight: 700;\n}\n\n.solution-categories-description {\n  width: 100%;\n  max-width: 650px;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0 auto;\n}\n\n.solution-cards {\n  padding: 0px 130px;\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n}\n\n.solution-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(147, 51, 234, 0.3);\n  border-radius: 20px;\n  padding: 60px 40px;\n  text-align: center;\n  position: relative;\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.solution-card::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n  background: linear-gradient(135deg, rgba(147, 51, 234, 0.3), rgba(147, 51, 234, 0.1));\n  border-radius: 20px;\n  z-index: -1;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.solution-card:hover::before {\n  opacity: 1;\n}\n\n.solution-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(147, 51, 234, 0.4);\n}\n\n.solution-card-icons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.solution-icon {\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.solution-icon:hover {\n  transform: scale(1.1);\n}\n.solution-icon-image{\n  width: 128px;\n  height: 128px;\n}\n.solution-card-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 24px;\n  line-height: 1.3;\n}\n\n.solution-card-description {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0 0 32px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.solution-card-cta {\n  background: linear-gradient(180deg, #622CD5 0%, #33176F 100%);\n  color: #ffffff;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.solution-card-cta:hover {\n  background: linear-gradient(180deg, #33176F 0%, #622CD5 100%);\n  transform: translateY(-2px);\n}\n\n/* FAQ Section Styles */\n.faq-section {\n  background: inherit;\n  padding: 120px 174px;\n  color: #ffffff;\n}\n\n.faq-container {\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.faq-header {\n  text-align: center;\n  margin-bottom: 80px;\n}\n\n.faq-title {\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 24px;\n  color: #e8e8e8;\n}\n\n.faq-title-highlight {\n  color: #ffffff;\n  font-size: 56px;\n  font-weight: 700;\n}\n\n.faq-subtitle {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0;\n}\n\n.faq-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0;\n  background: inherit;\n  position: relative;\n}\n\n.faq-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: inherit;\n  border: none;\n  padding: 30px 134px;\n  margin: 0;\n  background: inherit;\n}\n\n.faq-item::before {\n  content: '';\n  position: absolute;\n  left: 100px;\n  top: 50%;\n  width: 2px;\n  height: 24px;\n  background: #5E5472;\n  transform: translateY(-50%);\n  filter: blur(0.5px);\n}\n\n.faq-item::after {\n  content: '';\n  position: absolute;\n  right: 100px;\n  top: 50%;\n  width: 2px;\n  height: 24px;\n  background: #5E5472;\n  transform: translateY(-50%);\n  filter: blur(0.5px);\n}\n\n.faq-content::before,\n.faq-content::after {\n  content: '';\n  position: absolute;\n  top: -100px;\n  bottom: -40px; /* stretches with total content height */\n  width: 1px;\n  pointer-events: none;\n}\n\n.faq-content::before {\n  left: 100px; /* align with item padding */\n  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);\n  filter: blur(0.3px);\n}\n\n.faq-content::after {\n  right: 100px; /* align with item padding */\n  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);\n  filter: blur(0.3px);\n}\n\n.faq-divider {\n  display: block;\n  height: 1px;\n  background: linear-gradient(180deg, #0D061B 0%, #201C28 100%);\n  margin: 0 0; /* stops at vertical borders */\n}\n\n.faq-question {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  padding: 0 0 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n}\n\n.faq-question:hover {\n  color: #e8e8e8;\n}\n\n.faq-question-open {\n  color: #ffffff;\n}\n\n.faq-question-text {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.faq-toggle-icon {\n  font-size: 20px;\n  font-weight: bold;\n  transition: transform 0.3s ease;\n  min-width: 24px;\n  text-align: center;\n  margin-left: 16px;\n}\n\n.faq-question-open .faq-toggle-icon {\n  transform: rotate(180deg);\n}\n\n.faq-answer {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n}\n\n.faq-answer-open {\n  max-height: 500px;\n}\n\n.faq-answer-content {\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #bdbdbd;\n}\n\n/* Pricing Plans Styles */\n\n\n.pricing-plans::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background-image: \n    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);\n  background-size: 50px 50px; */\n  pointer-events: none;\n}\n\n.pricing-plans-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.pricing-plans-header {\n  text-align: center;\n  margin-bottom: 80px;\n}\n\n.pricing-plans-title {\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 24px;\n  color: #ffffff;\n}\n\n.pricing-plans-subtitle {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.pricing-plans-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.pricing-plan-card {\n  background: rgba(255, 255, 255, 0.02);\n  padding: 60px 40px;\n  text-align: center;\n  position: relative;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.pricing-plan-card:last-child {\n  border-right: none;\n}\n\n.pricing-plan-card:hover {\n  background: rgba(255, 255, 255, 0.05);\n  transform: translateY(-5px);\n}\n\n.pricing-plan-header {\n  margin-bottom: 40px;\n}\n\n.pricing-plan-name {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 20px;\n  letter-spacing: 2px;\n}\n\n.pricing-plan-price {\n  margin-bottom: 16px;\n}\n\n.pricing-plan-amount {\n  font-size: 48px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n}\n\n.pricing-plan-period {\n  font-size: 16px;\n  color: #bdbdbd;\n  margin-left: 4px;\n}\n\n.pricing-plan-description {\n  font-size: 16px;\n  color: #bdbdbd;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.pricing-plan-features {\n  margin-bottom: 40px;\n}\n\n.pricing-features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.pricing-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.pricing-feature-item:last-child {\n  margin-bottom: 0;\n}\n\n.pricing-feature-icon {\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, #9333ea, #7c3aed);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n\n.pricing-feature-text {\n  font-size: 16px;\n  color: #ffffff;\n  line-height: 1.4;\n}\n\n.pricing-plan-cta {\n  margin-top: auto;\n}\n\n.pricing-plan-button {\n  background: linear-gradient(135deg, #9333ea, #7c3aed);\n  color: #ffffff;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  max-width: 200px;\n}\n\n.pricing-plan-button:hover {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(147, 51, 234, 0.3);\n}\n\n/* Pricing Table Styles */\n.pricing-table {\n  padding: 150px 190px 0px 190px;\n  color: #ffffff;\n  position: relative;\n}\n\n.pricing-container {\n  max-width: 1200px;\n  margin-top: 150px;\n  margin: 0 auto;\n}\n\n.pricing-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.pricing-title {\n  max-width: 441px;\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 44px;\n  letter-spacing: 0;\n  margin: 0 auto 20px auto;\n  padding: 0 80px;\n  color: #ffffff;\n}\n\n.pricing-subtitle {\n  font-size: 16px;\n  line-height: 24px;\n  color: #bdbdbd;\n  margin: 0 auto;\n  padding: 0 120px;\n  max-width: 652px;\n}\n\n.pricing-plans {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0;\n  border-radius: 20px;\n  overflow: hidden;\n  background: transparent;\n  color: #ffffff;\n  position: relative;\n  width: 100%;\n}\n\n.pricing-card {\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 0px 40px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  flex: 1;\n  min-width: 0;\n}\n\n.pricing-card:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.pricing-card-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.pricing-price {\n  margin-bottom: 16px;\n}\n\n.pricing-amount {\n  font-size: 30px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n}\n\n.pricing-period {\n  font-size: 16px;\n  color: #bdbdbd;\n  margin-left: 4px;\n}\n\n.pricing-description {\n  font-size: 14px;\n  color: #bdbdbd;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.pricing-features {\n  flex: 1;\n  margin-bottom: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.pricing-feature-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n}\n\n.pricing-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 0 auto;\n}\n\n.pricing-feature-icon {\n  width: 24px;\n  height: 24px;\n  background: rgba(147, 51, 234, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9333ea;\n  flex-shrink: 0;\n}\n\n.pricing-feature-text {\n  font-size: 14px;\n  color: #ffffff;\n  line-height: 1.4;\n}\n\n.pricing-cta {\n  margin: auto auto;\n  width: 100%;\n  max-width: 200px;\n}\n\n.pricing-button {\n  width: 100%;\n  background: linear-gradient(180deg, rgba(98, 44, 213, 0.8), rgba(51, 23, 111, 0.8));\n  color: #ffffff;\n  border: none;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  /* box-shadow: \n    inset 0 1px 0 rgba(255, 255, 255, 0.3),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.2); */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.pricing-button:hover {\n  background: linear-gradient(180deg, rgba(51, 23, 111, 0.9), rgba(98, 44, 213, 0.9));\n  transform: translateY(-2px);\n  /* box-shadow:  */\n    /* inset 0 1px 0 rgba(255, 255, 255, 0.4),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.3),\n    0 10px 25px rgba(98, 44, 213, 0.3); */\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n}\n\n/* Pricing Table Responsive */\n@media (max-width: 1024px) {\n  .pricing-table {\n    padding: 150px 130px 0px 130px;\n  }\n  \n  .pricing-title {\n    font-size: 42px;\n  }\n  \n  .pricing-card {\n    padding: 50px 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .pricing-table {\n    padding: 150px 20px 0px 20px;\n  }\n   \n  .pricing-title {\n    font-size: 36px;\n  }\n  \n  .pricing-subtitle {\n    font-size: 16px;\n  }\n  \n  .pricing-plans {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .pricing-card {\n    padding: 0px 25px;\n  }\n  \n  .pricing-card:not(:last-child)::after {\n    display: none;\n  }\n  \n  .pricing-feature-item {\n    margin-bottom: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pricing-table {\n    padding: 150px 15px 60px 15px;\n  }\n  \n  \n  .pricing-title {\n    font-size: 28px;\n    line-height: 1.3;\n  }\n  \n  .pricing-subtitle {\n    font-size: 14px;\n  }\n  \n  .pricing-card {\n    padding: 0px 20px;\n  }\n  \n  .pricing-plan-name {\n    font-size: 16px;\n    letter-spacing: 1px;\n  }\n  \n  .pricing-amount {\n    font-size: 32px;\n  }\n  \n  .pricing-period {\n    font-size: 14px;\n  }\n  \n  .pricing-description {\n    font-size: 13px;\n  }\n  \n  .pricing-feature-icon {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .pricing-feature-text {\n    font-size: 13px;\n  }\n  \n  .pricing-button {\n    padding: 14px 20px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 320px) {\n  .pricing-title {\n    font-size: 24px;\n  }\n  \n  .pricing-plan-name {\n    font-size: 14px;\n  }\n  \n  .pricing-amount {\n    font-size: 28px;\n  }\n  \n  .pricing-button {\n    padding: 12px 16px;\n    font-size: 13px;\n  }\n}\n\n/* Workflow Features Styles */\n.workflow-features {\n  width: 100%;\n  padding: 120px 130px;\n  color: #ffffff;\n  background: inherit;\n}\n\n.workflow-features-container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.workflow-features-header {\n  max-width: 650px;\n  margin: 0 auto 80px auto;\n  text-align: center;\n}\n\n.workflow-features-title {\n  width: 100%;\n  max-width: 441px;\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1.3;\n  margin: 0 auto 24px auto;\n  color: #e8e8e8;\n}\n\n.workflow-features-title-highlight {\n  color: #a5a5b3;\n}\n\n.workflow-features-description {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0 auto;\n}\n\n.workflow-features-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(280px, 1fr));\n  /* gap: 60px 40px; */\n  position: relative;\n  align-items: start;\n}\n.workflow-feature-card {\n  text-align: center;\n  padding: 20px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 240px;\n}\n\n.workflow-feature-card:nth-child(1)::before,\n.workflow-feature-card:nth-child(2)::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: linear-gradient(180deg, #716786 0%, #232227 100%);\n  filter: blur(1px);\n}\n\n.workflow-feature-card:nth-child(3)::before,\n.workflow-feature-card:nth-child(4)::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: linear-gradient(0deg, #716786 0%, #232227 100%);\n  filter: blur(1px);\n}\n\n.workflow-feature-card::after {\n  content: '';\n  position: absolute;\n  left: 1px;\n  top: 50%;\n  width: 2px;\n  height: 24px;\n  background: #5E5472;\n  transform: translateY(-50%);\n  filter: blur(0.5px);\n}\n\n.workflow-feature-icon {\n  width: 60px;\n  height: 60px;\n  background: #1a1a1a;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n  color: #ffffff;\n}\n\n.workflow-feature-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 16px;\n  line-height: 1.3;\n}\n\n.workflow-feature-description {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #bdbdbd;\n  margin: 0;\n}\n\n/* Footer Styles */\n.footer {\n  position: relative;\n  overflow: hidden;\n}\n\n.footer-bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  z-index: 0;\n  pointer-events: none;\n  user-select: none;\n}\n\n.footer-container {\n  position: relative;\n  z-index: 1;\n  max-width: 1440px;\n  padding-top: clamp(32px, 6vw, 61px);\n  padding-bottom: clamp(24px, 4vw, 46px);\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 397px;\n}\n\n.footer-main {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  /* padding-left: clamp(20px, 9vw, 130px);\n  padding-right: clamp(20px, 4vw, 40px); */\n  padding: 0px 130px;\n}\n\n.footer-brand {\n  max-width: 337px;\n  min-width: 260px;\n  /* margin-right: clamp(24px, 6vw, 84px); */\n  margin-bottom: 24px;\n}\n\n.footer-brand-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.footer-brand-logo {\n  width: 24px;\n  height: 24px;\n}\n\n.footer-brand-name {\n  color: white;\n  font-size: 25px;\n  font-weight: 600;\n  letter-spacing: -4%;\n}\n\n.footer-brand-desc {\n  color: rgba(255,255,255,0.7);\n  font-size: 14px;\n  margin: 0;\n}\n\n.footer-nav {\n  display: flex;\n  gap: 130px;\n  flex-wrap: wrap;\n}\n\n.footer-nav-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-nav-heading {\n  color: white;\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 16px;\n  line-height: 22px;\n}\n\n.footer-nav-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 9px;\n}\n\n.footer-nav-link {\n  color: rgba(255,255,255,0.8);\n  text-decoration: none;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.footer-nav-link:hover {\n  color: rgba(255,255,255,1);\n}\n\n.footer-copyright {\n  color: rgba(255,255,255,0.7);\n  font-size: 13px;\n  margin: 0;\n  text-align: center;\n}\n\n/* Media Queries */\n\n@media (min-width: 1200px) {\n  .hero {\n    min-height: 753px;\n  }\n  \n  .hero-title {\n    font-size: 65px;\n    line-height: 130.2%;\n  }\n  \n  .br-desktop {\n    display: inline;\n  }\n  \n  /* Hide hamburger menu on large screens */\n  .nav-desktop {\n    display: flex !important;\n  }\n  \n  .auth-actions {\n    display: flex !important;\n  }\n  \n  .mobile-menu-btn {\n    display: none !important;\n  }\n  \n  .mobile-menu {\n    display: none !important;\n  }\n\n\n}\n\n\n@media (max-width: 1200px) and (min-width: 900px) {\n  .nav-desktop {\n    display: flex !important;\n  }\n  .auth-actions {\n    display: flex !important;\n  }\n  .mobile-menu-btn {\n    display: none !important;\n  }\n  .mobile-menu {\n    display: none !important;\n  }\n  \n  .hero {\n    min-height: 753px;\n  }\n  \n  .hero-title {\n    font-size: 55px;\n  }\n  \n  .br-desktop {\n    display: inline;\n  }\n\n  .pricing-table {\n    padding: 150px 130px 0px 130px;\n  }\n\n  \n}\n\n@media (max-width: 900px) {\n  .header-container {\n    padding: 16px 20px;\n  }\n  \n  .nav-desktop {\n    display: none !important;\n  }\n  \n  .auth-actions {\n    display: none !important;\n  }\n  \n  .mobile-menu-btn {\n    display: flex !important;\n  }\n  \n  .mobile-menu {\n    display: block !important;\n  }\n  \n  .hero {\n    margin: 80px auto 34px auto;\n    min-height: 650px;\n    padding: 40px 110px;\n  }\n  \n  .hero-title {\n    font-size: 55px;\n    padding: 0px 20px;\n  }\n  \n  .hero-subtitle {\n    font-size: 15px;\n    display: none;\n  }\n\n  .pricing-table {\n    padding: 100px 60px 0px 60px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .footer-main {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n \n  .footer-nav {\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 1199px) {\n  /* .footer-main {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  } */\n  \n  .footer-brand {\n    margin-right: 0;\n    margin-bottom: 32px;\n  }\n  \n  .footer-nav {\n    /* justify-content: space-between; */\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 80px;\n  }\n}\n\n/* FAQ Section Responsive */\n@media (max-width: 1200px) {\n  .faq-section {\n    padding: 100px 100px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .faq-section {\n    padding: 100px 60px;\n  }\n  \n  .faq-title {\n    font-size: 42px;\n  }\n  \n  .faq-title-highlight {\n    font-size: 48px;\n  }\n  \n  .faq-subtitle {\n    font-size: 16px;\n  }\n  \n  .faq-question-text {\n    font-size: 16px;\n  }\n  \n  /* .faq-item {\n    padding: 25px 80px;\n    margin: 0;\n  } */\n\n  .faq-content::before { left: 80px; }\n  .faq-content::after { right: 80px; }\n  .faq-divider { margin: 0 80px; }\n  .faq-item::before { left: 80px; }\n  .faq-item::after { right: 80px; }\n  \n\n}\n\n@media (max-width: 768px) {\n  .faq-section {\n    padding: 80px 40px;\n  }\n  \n  .faq-header {\n    margin-bottom: 60px;\n  }\n  \n  .faq-title {\n    font-size: 36px;\n  }\n  \n  .faq-title-highlight {\n    font-size: 40px;\n  }\n  \n  .faq-subtitle {\n    font-size: 15px;\n  }\n  \n  .faq-content {\n    grid-template-columns: 1fr;\n  }\n  \n  /* .faq-item {\n    padding: 20px 40px;\n    margin: 0;\n  } */\n\n  .faq-content::before { left: 40px; }\n  .faq-content::after { right: 40px; }\n  .faq-divider { margin: 0 40px; }\n  .faq-item::before { left: 40px; }\n  .faq-item::after { right: 40px; }\n\n  .faq-item {\n    padding: 30px 60px;\n  }\n   \n  .faq-question-text {\n    font-size: 15px;\n  }\n  \n  .faq-toggle-icon {\n    font-size: 18px;\n    margin-left: 12px;\n  }\n  \n  .faq-answer-content {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 480px) {\n  .faq-section {\n    padding: 60px 20px;\n  }\n  \n  .faq-header {\n    margin-bottom: 50px;\n  }\n  \n  .faq-title {\n    font-size: 28px;\n    line-height: 1.3;\n  }\n  \n  .faq-title-highlight {\n    font-size: 32px;\n  }\n  \n  .faq-subtitle {\n    font-size: 14px;\n  }\n  \n  .faq-item {\n    padding: 15px 20px;\n    margin: 0;\n  }\n\n  .faq-content::before { left: 20px; }\n  .faq-content::after { right: 20px; }\n  .faq-divider { margin: 0 20px; }\n  \n  .faq-question {\n    padding: 0 0 10px 0;\n  }\n  \n  .faq-question-text {\n    font-size: 14px;\n    padding-right: 10px;\n  }\n  \n  .faq-toggle-icon {\n    font-size: 16px;\n    margin-left: 10px;\n  }\n  \n  .faq-answer-content {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n}\n\n@media (max-width: 320px) {\n  .faq-item {\n    padding: 12px 10px;\n    margin: 0;\n  }\n\n  .faq-content::before { left: 10px; }\n  .faq-content::after { right: 10px; }\n  .faq-divider { margin: 0 10px; }\n  \n  .faq-title {\n    font-size: 24px;\n  }\n  \n  .faq-title-highlight {\n    font-size: 28px;\n  }\n  \n  .faq-subtitle {\n    font-size: 13px;\n  }\n  \n  .faq-question-text {\n    font-size: 13px;\n  }\n  \n  .faq-toggle-icon {\n    font-size: 14px;\n    margin-left: 8px;\n  }\n  \n  .faq-answer-content {\n    font-size: 12px;\n  }\n}\n\n/* Pricing Plans Responsive */\n@media (max-width: 1024px) {\n  \n  .pricing-plans-title {\n    font-size: 42px;\n  }\n  \n  .pricing-plans-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .pricing-plan-card {\n    padding: 50px 30px;\n  }\n  \n  .pricing-plan-amount {\n    font-size: 40px;\n  }\n  \n  .pricing-feature-text {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .pricing-plans {\n    padding: 0px 20px;\n  }\n  \n  .pricing-plans-header {\n    margin-bottom: 60px;\n  }\n  \n  .pricing-plans-title {\n    font-size: 36px;\n  }\n  \n  .pricing-plans-subtitle {\n    font-size: 16px;\n  }\n  \n  .pricing-plans-grid {\n    grid-template-columns: 1fr;\n    border-radius: 16px;\n  }\n  \n  .pricing-plan-card {\n    padding: 40px 30px;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .pricing-plan-card:last-child {\n    border-bottom: none;\n  }\n  \n  .pricing-plan-header {\n    margin-bottom: 30px;\n  }\n    \n  .pricing-plan-amount {\n    font-size: 36px;\n  }\n  \n  .pricing-plan-description {\n    font-size: 15px;\n  }\n  \n  .pricing-plan-features {\n    margin-bottom: 30px;\n  }\n  \n  .pricing-feature-item {\n    margin-bottom: 12px;\n  }\n  \n  .pricing-feature-text {\n    font-size: 14px;\n  }\n  \n  .pricing-plan-button {\n    padding: 14px 28px;\n    font-size: 15px;\n  }\n\n  .pricing-button {\n    width: 200px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .pricing-plans {\n    padding: 0px 15px;\n  }\n  \n  .pricing-plans-header {\n    margin-bottom: 50px;\n  }\n  \n  .pricing-plans-title {\n    font-size: 28px;\n    line-height: 1.3;\n  }\n  \n  .pricing-plans-subtitle {\n    font-size: 14px;\n  }\n  \n  .pricing-plan-card {\n    padding: 30px 20px;\n  }\n  \n  .pricing-plan-header {\n    margin-bottom: 25px;\n  }\n  \n  .pricing-plan-name {\n    font-size: 16px;\n    margin-bottom: 15px;\n  }\n  \n  .pricing-plan-amount {\n    font-size: 32px;\n  }\n  \n  .pricing-plan-period {\n    font-size: 14px;\n  }\n  \n  .pricing-plan-description {\n    font-size: 14px;\n  }\n  \n  .pricing-plan-features {\n    margin-bottom: 25px;\n  }\n  \n  .pricing-feature-item {\n    gap: 10px;\n    margin-bottom: 10px;\n  }\n  \n  .pricing-feature-icon {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .pricing-feature-text {\n    font-size: 13px;\n  }\n  \n  .pricing-plan-button {\n    padding: 12px 24px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 320px) {\n  .pricing-plans-title {\n    font-size: 24px;\n  }\n  \n  .pricing-plans-subtitle {\n    font-size: 13px;\n  }\n  \n  .pricing-plan-card {\n    padding: 25px 15px;\n  }\n  \n  .pricing-plan-name {\n    font-size: 14px;\n  }\n  \n  .pricing-plan-amount {\n    font-size: 28px;\n  }\n  \n  .pricing-feature-text {\n    font-size: 12px;\n  }\n  \n  .pricing-plan-button {\n    padding: 10px 20px;\n    font-size: 13px;\n  }\n}\n\n/* Solution Categories Responsive */\n@media (max-width: 1200px) {\n  .solution-categories {\n    padding: 100px 80px 0px 80px;\n  }\n  .solution-categories-bg {\n    height: 650px;\n  }\n  .solution-categories-title {\n    font-size: 30px;\n  }\n\n  .solution-categories-description {\n    font-size: 12px;\n    max-width: 700px;\n  }\n\n  .solution-categories-description {\n    font-size: 16px;\n    max-width: 700px;\n  }\n  .solution-cards {\n    padding: 0px 10px;\n  }\n\n  .solution-card {\n    /* padding: 50px 30px; */\n    background-size: cover !important;\n    background-position: center !important;\n  }\n  \n  .solution-card-title {\n    font-size: 28px;\n  }\n  \n  .solution-card-description {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .solution-categories-title {\n    font-size: 30px;\n  }\n\n  /* .solution-categories-description {\n    display: none;\n  } */\n\n  .solution-categories-bg-image {\n    scale: 0.8;\n  }\n\n  .solution-cards {\n    padding: 0px 0px;\n  }\n \n\n}\n\n@media (max-width: 768px) {\n  .solution-categories {\n    padding: 80px 30px 0px 30px;\n  }\n\n  .solution-categories-bg {\n    height: 600px;\n  }\n\n  .solution-categories-bg-image {\n    scale: 0.7;\n  }\n  \n  .solution-categories-header {\n    /* margin-bottom: 60px; */\n    padding: 50px 25px;\n  }\n  \n  .solution-categories-title {\n    font-size: 30px;\n  }\n  \n  .solution-categories-title-highlight {\n    font-size: 40px;\n  }\n  \n  .solution-categories-description {\n    font-size: 15px;\n    max-width: 100%;\n    margin-top: 20px;\n  }\n  \n  .solution-cards {\n    gap: 40px;\n    padding: 0px 20px;\n  }\n  \n  .solution-card {\n    padding: 40px 25px;\n    background-size: cover !important;\n    background-position: center !important;\n  }\n  \n  .solution-card-icons {\n    gap: 15px;\n    margin-bottom: 30px;\n\n  }\n  \n  .solution-card-title {\n    font-size: 24px;\n  }\n  \n  .solution-card-description {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  .solution-card-cta {\n    padding: 14px 28px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .solution-categories {\n    padding: 60px 20px 0px 20px;\n  }\n  .solution-categories-bg-image {\n    scale: 0.6;\n  }\n  \n  .solution-categories-header {\n    padding: 40px 20px;\n  }\n  \n  .solution-categories-title {\n    font-size: 28px;\n    line-height: 1.3;\n  }\n  .solution-categories-description {\n    display: none;\n  }\n\n  .solution-categories-bg {\n    height: 400px;\n  }\n  .solution-icon-image{\n    width: 64px;\n    height: 64px;\n  }\n  .solution-categories-title-highlight {\n    font-size: 32px;\n  }\n  \n  .solution-categories-description {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-top: 16px;\n  }\n  \n  .solution-cards {\n    gap: 30px;\n  }\n  \n  .solution-card {\n    padding: 30px 20px;\n    background-size: cover !important;\n    background-position: center !important;\n  }\n  \n  .solution-card-icons {\n    gap: 12px;\n    margin-bottom: 25px;\n    flex-wrap: wrap;\n  }\n  \n  .solution-icon {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .solution-card-title {\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .solution-card-description {\n    font-size: 13px;\n    line-height: 1.4;\n    margin-bottom: 25px;\n  }\n  \n  .solution-card-cta {\n    padding: 12px 24px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 320px) {\n  .solution-categories-title {\n    font-size: 24px;\n  }\n\n  .solution-categories-bg-image {\n    scale: 0.5;\n  }\n  \n  .solution-categories-title-highlight {\n    font-size: 28px;\n  }\n  \n  .solution-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .solution-card-title {\n    font-size: 18px;\n  }\n  \n  .solution-card-description {\n    font-size: 12px;\n  }\n  \n  .solution-card-cta {\n    padding: 10px 20px;\n    font-size: 12px;\n  }\n}\n\n/* Testimonials Section Styles */\n.testimonials-section {\n  padding: 170px 130px 0px 130px ;\n  background: inherit;\n  color: #ffffff;\n  position: relative;\n}\n\n.testimonials-container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.testimonials-header {\n  text-align: center;\n  margin-bottom: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.testimonials-title {\n  width: 441px;\n  padding: 0 40px;\n  margin: 0 auto;\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 44px;\n  margin: 0 0 24px;\n  color: #ffffff;\n}\n\n.testimonials-subtitle {\n  width: 100%;\n  max-width: 541px;\n  padding: 0 40px;\n  margin: 0 auto;\n  font-size: 14px;\n  line-height: 24px;\n  color: #bdbdbd;\n  margin: 0;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  position: relative;\n}\n\n.testimonial-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 40px 30px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  position: relative;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.testimonial-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n}\n\n.testimonial-content {\n  flex: 1;\n  margin-bottom: 30px;\n}\n\n.testimonial-quote {\n  font-size: 14px;\n  line-height: 150%;\n  color: #e8e8e8;\n  margin: 0;\n  /* font-style: italic; */\n}\n\n.testimonial-author {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.testimonial-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.testimonial-author-info {\n  flex: 1;\n}\n\n.testimonial-author-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 4px;\n  line-height: 1.3;\n}\n\n.testimonial-author-title {\n  font-size: 14px;\n  color: #bdbdbd;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Testimonials Section Responsive */\n@media (max-width: 1200px) {\n  .testimonials-section {\n    padding: 100px 80px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .testimonials-section {\n    padding: 100px 40px;\n  }\n  \n  .testimonials-title {\n    font-size: 42px;\n  }\n  \n  .testimonials-grid {\n    gap: 30px;\n  }\n  \n  .testimonial-card {\n    padding: 35px 25px;\n  }\n  \n  .testimonial-quote {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .testimonials-section {\n    padding: 80px 30px;\n  }\n  \n  .testimonials-header {\n    margin-bottom: 60px;\n  }\n  \n  .testimonials-title {\n    font-size: 36px;\n    line-height: 1.3;\n  }\n  \n  .testimonials-subtitle {\n    font-size: 16px;\n    line-height: 1.5;\n  }\n  \n  .testimonials-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n  \n  .testimonial-card {\n    padding: 30px 25px;\n    margin: 0 auto;\n    max-width: 500px;\n  }\n  \n  .testimonial-quote {\n    font-size: 15px;\n    line-height: 1.6;\n  }\n  \n  .testimonial-author {\n    gap: 14px;\n  }\n  \n  .testimonial-avatar {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .testimonial-author-name {\n    font-size: 15px;\n  }\n  \n  .testimonial-author-title {\n    font-size: 13px;\n  }\n}\n\n/* Large tablets and small desktops */\n@media (min-width: 768px) and (max-width: 1200px) {\n \n  .workflow-features-title {\n    font-size: 42px;\n  }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n  .workflow-features {\n    /* margin: 0 130px 0 130px; */\n    padding: 40px 50px;\n  }\n  \n  .workflow-features-header {\n    margin-bottom: 40px;\n  }\n  \n  .workflow-features-description {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  .workflow-features-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .workflow-feature-card {\n    padding: 15px;\n  }\n  \n  .workflow-feature-icon {\n    width: 45px;\n    height: 45px;\n    margin-bottom: 20px;\n  }\n  \n  .workflow-feature-title {\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n  \n  .workflow-feature-description {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 768px) {\n  /* .workflow-features {\n    margin: 0 130px 0 130px;\n    padding: 30px 10px;\n  } */\n  \n  .workflow-features-title {\n    font-size: 24px;\n  }\n  \n  .workflow-features-description {\n    font-size: 13px;\n  }\n  \n  .workflow-feature-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .workflow-feature-title {\n    font-size: 16px;\n  }\n  \n  .workflow-feature-description {\n    font-size: 12px;\n  }\n\n  .footer-nav {\n    gap: 20px;\n  }\n\n  .hero {\n    margin: 60px auto 34px auto;\n    min-height: 600px;\n    padding: 40px 60px;\n  }\n  \n  .hero-title {\n    font-size: 40px;\n    padding: 0px 20px;\n  }\n\n  .footer-main {\n    padding: 0px 80px;\n  }\n}\n\n@media (max-width: 480px) {\n  .testimonials-section {\n    padding: 60px 20px;\n  }\n  \n  .testimonials-header {\n    margin-bottom: 50px;\n  }\n  \n  .testimonials-title {\n    font-size: 28px;\n    line-height: 1.3;\n    margin-bottom: 16px;\n  }\n  \n  .testimonials-subtitle {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  .testimonials-grid {\n    gap: 25px;\n  }\n  \n  .testimonial-card {\n    padding: 25px 20px;\n    margin: 0 auto;\n    max-width: 100%;\n  }\n  \n  .testimonial-content {\n    margin-bottom: 25px;\n  }\n  \n  .testimonial-quote {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  .testimonial-author {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n  \n  .testimonial-avatar {\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n  }\n  \n  .testimonial-author-info {\n    flex: 1;\n    min-width: 0;\n  }\n  \n  .testimonial-author-name {\n    font-size: 14px;\n    margin-bottom: 2px;\n  }\n  \n  .testimonial-author-title {\n    font-size: 12px;\n    line-height: 1.4;\n  }\n\n  .hero {\n    margin: 40px auto 34px auto;\n    min-height: 500px;\n    padding: 40px 20px;\n  }\n  \n  .hero-title {\n    font-size: 35px;\n    padding: 0px 20px;\n  }\n  .cta-button {\n    padding: 16px 10px;\n  }\n\n  .footer-main {\n    padding: 0px 40px;\n  }\n}\n\n@media (max-width: 320px) {\n  .testimonials-section {\n    padding: 50px 15px;\n  }\n  \n  .testimonials-title {\n    font-size: 24px;\n    line-height: 1.2;\n  }\n  \n  .testimonials-subtitle {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n  \n  .testimonial-card {\n    padding: 20px 15px;\n    margin: 0 auto;\n    max-width: 100%;\n  }\n  \n  .testimonial-quote {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n  \n  .testimonial-author {\n    gap: 10px;\n  }\n  \n  .testimonial-avatar {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .testimonial-author-name {\n    font-size: 13px;\n    margin-bottom: 1px;\n  }\n  \n  .testimonial-author-title {\n    font-size: 11px;\n    line-height: 1.3;\n  }\n}\n\n/* Workflow Features Responsive */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
